<!-- 功能列表下拉显示 -->
<script lang='ts' setup>
import { Right } from '@element-plus/icons-vue'
import { downShowType } from '../listData/downShow'
import { ref } from 'vue';
import { useRouter } from 'vue-router';
let props = defineProps<{ listData: downShowType }>()
//第几个li列
let liNum = ref<number>()
let liOver = (num: number) => {
    liNum.value = num
}
//子路由
const router = useRouter()
const emit = defineEmits(['onClick-li','downFalse'])
let pathFn = (str: any,num:any) => {
    if (str.slice(0, -1)!='section' && str!=undefined) {
        router.push(str)
        emit('onClick-li', false)
    }
    else{
        if(num==1){
            router.push({ path: '/about.html', query: { 'about_nav': str } })
        }else if(num==4){
            router.push({ path: '/partner.html'})
        }
        else if(num==5){
            router.push({ path: '/contact.html' })
        }else if(num==6){
            router.push({ path: '/join_us.html' })
        }else if(num==21){
            router.push({ path: '/products.html' })
        }
        else if(num==22){
            router.push({ path: '/terminal.html' })
        }
        else if(num==23){
            router.push({ path: '/wisdom.html' })
        }
        else if(num==31){
            router.push({ path: '/performance.html' })
        }
        else if(num==32){
            router.push({ path: '/application_case.html' })
        }
        else if(num==33){
            router.push({ path: '/realistic_picture.html' })
        }
    }
    emit('downFalse',false)
}
function getIcon(name: string) {
    return new URL(`${name}`, import.meta.url).href;
}
</script>
<template>
    <div class="downshow">
        <div class="downshowLeeft">
            <div class="title">{{ props.listData.title }}</div>
            <div class="introductory">{{ props.listData.introductory }}</div>
            <div class="more">
                <router-link :to="{path:props.listData.path_url??'/'}">
                    进一步了解
                    <Right style="width: 1em; height: 1em; margin: -6px 0px;font-size: 25px;" />
                </router-link>
            </div>
        </div>
        <div class="downshowMiddle"></div>
        <div class="downshowRight">
            <ul class="imgList">
                <li v-for="(item, index) in props.listData.urls" @mouseover="liOver(index)"
                    @click="pathFn(item.path ? item.path : item.section,item.id)">
                    <div>
                        <el-image class="image" style="width: 100px; height: 100px" :src="getIcon(item.url)" fit="cover" />
                    </div>
                    <div class="partText">{{ item.partText }}</div>
                    <div class="across" v-if="liNum == index"></div>
                </li>
            </ul>
        </div>
    </div>
</template>
<style  lang='less' scoped>
.flex {
    display: flex;
    align-items: center;
}
.downshow {
    .flex();
    color: #fff;

    .downshowMiddle {
        width: 1px;
        height: 250px;
        background-color: #ffffffce;
        margin: 0 30px;
    }

    .downshowLeeft {
        width: 400px;
        height: 220px;
        padding: 16px 0;
        margin-left: 20px;
        .title {
            font-size: 20px;
        }
        .introductory {
            font-size: 14px;
            text-indent: 2em;
            line-height: 32px;
            border-bottom: 1px #fff dotted;
            margin-bottom: 10px;
            height: 120px;
        }
    }

    //动画
    @keyframes zoomFn {
        0% {
            transform: scale(1, 1);
        }

        100% {
            transform: scale(1.5, 1.5);
        }
    }

    //动画

    .imgList {
        .flex();

        li {
            .flex();
            font-size: 14px;
            margin: 20px;
            flex-direction: column;
            justify-content: center;

            .image {
                /deep/ .el-image__inner {
                    animation: zoomFn 5s ease infinite;
                    -webkit-animation: zoomFn 5s ease infinite;
                    transition: all ease;
                }
            }

            .partText {
                margin: 20px 0 10px 0;
            }

            @keyframes acrossAnination {
                0% {
                    width: 0;
                }

                100% {
                    width: 100px;
                }
            }

            .across {
                content: '';
                z-index: 999;
                width: 0;
                height: 3px;
                opacity: 1;
                background-color: #e60012;
                transition: all ease;
                animation: acrossAnination 1.5s ease forwards;
                -webkit-animation: acrossAnination 1.5s ease forwards;
            }
        }
    }
}</style>